import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";

type ForwardingAgentId = Branded<string, "ForwardingAgentId">;
const forwardingAgentIdPrefix = "forwarding_agent__";
const alfredForwardingAgentId =
    `${forwardingAgentIdPrefix}alfred` as ForwardingAgentId;
const {
    factory: forwardingAgentIdFactory,
    assert: isForwardingAgentId,
    zodSchema: forwardingAgentIdZodSchema,
} = genericId<ForwardingAgentId>(forwardingAgentIdPrefix, {
    regexMatch: /(^forwarding_agent_.*$)/,
});
export {
    alfredForwardingAgentId,
    forwardingAgentIdFactory,
    forwardingAgentIdZodSchema,
    isForwardingAgentId,
};
export type { ForwardingAgentId };
